import { render } from "./quote_setup.vue?vue&type=template&id=6c2bc746"
import script from "./quote_setup.vue?vue&type=script&lang=js"
export * from "./quote_setup.vue?vue&type=script&lang=js"

import exportComponent from "/usr/lib/node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__